/**
 * Defines the FBX loader plugin metadata.
 */
export const FBXFileLoaderMetadata = {
    name: "fbx",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".fbx": { isBinary: true },
    },
};
//# sourceMappingURL=fbxFileLoader.metadata.js.map